import React from 'react';
import styles from './RenderEcmRichText.module.less';
import cx from 'classnames';
import PropTypes from 'prop-types';

const RenderEcmRichText = ({ content, className }) => {
  return (
    <div
      className={cx([styles.container, className])}
      dangerouslySetInnerHTML={{ __html: content }}
      data-testid="rich-text"
    />
  );
};

RenderEcmRichText.propTypes = {
  content: PropTypes.string.isRequired,
  className: PropTypes.string
};

RenderEcmRichText.defaultProps = {
  className: undefined
};

export default RenderEcmRichText;
